import {
  Divider,
  Form,
  Input,
  InputNumber,
  Radio,
  Select,
  Space,
  Tag,
} from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import svg40 from "../../../../assets/svg/svg40.svg";

function LandUse({ form }) {
  const { crops } = useSelector((state) => state.fetch);
  const { activeObjSchemes } = useSelector((state) => ({
    activeObjSchemes: state.obj.activeObj["schemes"],
  }));
  const plainOptions = ["Yes", "No"];

  const [blocks, setBlocks] = useState([]);

  const [inputValue, setInputValue] = useState("");

  const handleAddBlock = () => {
    if (inputValue.trim() && !blocks.includes(inputValue)) {
      const newBlocks = [...blocks, inputValue];
      setBlocks(newBlocks);
      setInputValue("");
      form.setFieldsValue({ schBlocks: newBlocks });
    }
  };

  const handleRemoveBlock = (block) => {
    const newBlocks = blocks.filter((b) => b !== block);
    setBlocks(newBlocks);
    form.setFieldsValue({ schBlocks: newBlocks });
  };

  useEffect(() => {
    if (activeObjSchemes?.schBlocks) {
      setBlocks(activeObjSchemes?.schBlocks?.split(",")?.map((b) => b?.trim()));
    }
  }, [activeObjSchemes, form]);

  return (
    <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
      <Form.Item
        name="schLandSize"
        label={"Developed Area (Acre)"}
        rules={[
          {
            required: true,
            message: "Please add developed area",
          },
        ]}
      >
        <InputNumber
          suffix="Acre"
          min={0}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
          placeholder="Enter value"
          className="input flex"
        />
      </Form.Item>
      <Form.Item
        name="schSize"
        className=""
        label={"Scheme Size"}
        rules={[
          {
            required: true,
            message: "Please select scheme size",
          },
        ]}
      >
        <Input disabled className="input" />
      </Form.Item>
      <Form.Item
        name="schIrrigationArea"
        label={"Irrigated Area"}
        rules={[
          {
            required: true,
            message: "Please add Irrigated Area",
          },
        ]}
      >
        <InputNumber
          suffix="Acre"
          min={0}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
          placeholder="Enter value"
          className="input flex"
        />
      </Form.Item>
      <Form.Item
        name="schPotentialSize"
        label={"Potential Size"}
        rules={[
          {
            required: true,
            message: "Please add potential size",
          },
        ]}
      >
        <InputNumber
          suffix="Acre"
          min={0}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
          placeholder="Enter value"
          className="input flex"
        />
      </Form.Item>
      <Form.Item
        name="schLandUse"
        label={"land use"}
        rules={[
          {
            required: false,
            message: "Please add land use",
          },
        ]}
      >
        <Input placeholder="land use" className="input" />
      </Form.Item>
      {/* <Form.Item
        label={"In Peformance Contract"}
        name="schPerformanceContract"
        rules={[
          {
            required: true,
            message: "Required field",
          },
        ]}
      >
        <Radio.Group
          options={plainOptions} 
        />
      </Form.Item> */}
      <Form.Item
        name="schAverageHouseHoldIncomeBefore"
        label={"Average household income before"}
        rules={[
          {
            required: false,
            message: "Please add average household income before",
          },
        ]}
      >
        <InputNumber
          min={0}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
          placeholder="Ksh. e.g 500"
          className="input flex"
        />
      </Form.Item>
      <Form.Item
        name="schAverageHouseHoldIncomeAfter"
        label={"Average household income After"}
        rules={[
          {
            required: false,
            message: "Please add average household income After",
          },
        ]}
      >
        <InputNumber
          min={0}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
          placeholder="Ksh. e.g 500"
          className="input flex"
        />
      </Form.Item>
      <Form.Item
        name="schHouseholdNo"
        label={"Number of households"}
        rules={[
          {
            required: true,
            message: "Please add number of households",
          },
        ]}
      >
        <InputNumber
          min={0}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
          placeholder="Enter value"
          className="input flex"
        />
      </Form.Item>
      <Form.Item
        name="schFarmersNumber"
        label={"Number of farmers"}
        rules={[
          {
            required: true,
            message: "Please add number of farmers",
          },
        ]}
      >
        <InputNumber
          min={0}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
          placeholder="Enter value"
          className="input flex"
        />
      </Form.Item>
      <Form.Item
        name="schStaffEmployedNumber"
        label={"Number of Staff employed by Scheme"}
        rules={[
          {
            required: true,
            message: "Please add Number of Staff employed by Scheme",
          },
        ]}
      >
        <InputNumber
          min={0}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
          placeholder="Enter value"
          className="input flex"
        />
      </Form.Item>
      <Form.Item
        name="schBlocks"
        label={"Block"}
        rules={[
          {
            required: true,
            message: "Please add block",
          },
        ]}
      >
        <div className="flex w-full gap-x-[1rem]">
          <Input
            className="input"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder="Type and click + to add"
            onPressEnter={handleAddBlock}
          />
          <button
            type="button"
            onClick={handleAddBlock}
            className="cstm-btn !border-none !w-[50px] !bg-white !text-darkBlue"
          >
            Add <img src={svg40} alt="svg40" />
          </button>
        </div>

        <div className="mt-[.31rem]">
          {blocks?.map((block) => (
            <Tag
              className="rounded-[.25rem] bg-[#F1F3F5] px-[.3125rem] py-[.25rem] gap-[.25rem]"
              key={block}
              closable
              onClose={() => handleRemoveBlock(block)}
            >
              {block}
            </Tag>
          ))}
        </div>
      </Form.Item>
      <Form.Item
        label="Major Crops"
        name="schCrops"
        rules={[{ required: true, message: "Required field" }]}
      >
        <Select
          mode="multiple"
          allowClear
          showSearch
          dropdownRender={(menu) => (
            <>
              <Space style={{ padding: "8px 8px 4px" }}>
                <span className="select-info mt-1">
                  Choose one or more of the following crops
                </span>
              </Space>
              <Divider style={{ margin: "8px 0" }} />
              {menu}
            </>
          )}
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.children?.toLowerCase() ?? "").includes(
              input.toLowerCase()
            )
          }
          tagRender={(props) => {
            const { label, closable, onClose } = props;
            return (
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  padding: "4px 8px",
                  margin: "2px",
                  borderRadius: "4px",
                  background: "#f5f5f5",
                }}
              >
                {label}
                {closable && (
                  <span
                    onClick={onClose}
                    style={{
                      marginLeft: "8px",
                      cursor: "pointer",
                      color: "red",
                    }}
                  >
                    ×
                  </span>
                )}
              </span>
            );
          }}
          dropdownStyle={{ maxHeight: 400, overflowY: "auto" }}
        >
          {crops?.map((item) => (
            <Select.Option key={item?.cropId} value={item?.cropName}>
              {item?.cropName}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </div>
  );
}

export default LandUse;
